module.exports = __webpack_public_path__ + "static/media/Specialized.9a8d94ec.jpg";